export default __webpack_public_path__ + "static/media/appai_logo.ab7b7ae8.svg";